export default __webpack_public_path__ + "static/media/img3.52af5bdf.PNG";